// extracted by mini-css-extract-plugin
export default {"box":"ScoreOverTime_box__rjzBn","info":"ScoreOverTime_info__4OR5p","header":"ScoreOverTime_header__iQVAU","title":"ScoreOverTime_title__MkFJE","text":"ScoreOverTime_text__s6mM+"};